import type { ChatState, PendingAttachmentsState } from './interfaces';

export function pendingAttachmentsReducer(
  state: PendingAttachmentsState.State,
  action: ChatState.Action
): PendingAttachmentsState.State {
  switch (action.type) {
    case 'pending-attachment/file-staged':
      return state.concat({
        clientId: action.payload.clientId,
        identifier: '',
        name: action.payload.name,
        mimeType: action.payload.mimeType,
        sizeBytes: action.payload.sizeBytes,
        file: action.payload.file,
        status: 'staged',
        progress: 0,
      });

    case 'pending-attachment/file-removed':
      return state.filter((a) => a.clientId !== action.payload.clientId);

    case 'pending-attachment/upload-started':
      // Correlate by clientId, then stamp the server-issued UUID onto the entry.
      return state.map((a) =>
        a.clientId === action.payload.clientId
          ? { ...a, identifier: action.payload.identifier, status: 'uploading', progress: 0 }
          : a
      );

    case 'pending-attachment/upload-progress':
      return state.map((a) =>
        a.identifier === action.payload.identifier ? { ...a, progress: action.payload.progress } : a
      );

    case 'pending-attachment/upload-succeeded':
      return state.map((a) =>
        a.identifier === action.payload.identifier
          ? { ...a, status: 'success', fileUri: action.payload.fileUri, checksum: action.payload.checksum }
          : a
      );

    case 'pending-attachment/upload-failed': {
      const { payload } = action;
      const isTarget = (a: PendingAttachmentsState.PendingAttachment) =>
        'clientId' in payload ? a.clientId === payload.clientId : a.identifier === payload.identifier;
      return state.map((a) =>
        isTarget(a) ? { ...a, status: 'error', errorMessage: payload.errorMessage } : a
      );
    }

    case 'pending-attachment/extraction-updated':
      return state.map((a) =>
        a.identifier === action.payload.identifier
          ? {
              ...a,
              extraction: {
                status: action.payload.status,
                error: action.payload.error,
              },
            }
          : a
      );

    case 'query-submitted':
      return [];

    default:
      return state;
  }
}
